import { render, staticRenderFns } from "./team.vue?vue&type=template&id=59de37c8&scoped=true"
import script from "./team.vue?vue&type=script&lang=ts"
export * from "./team.vue?vue&type=script&lang=ts"
import style0 from "./team.vue?vue&type=style&index=0&id=59de37c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59de37c8",
  null
  
)

export default component.exports